import { gql } from '@apollo/client';

export const comByUserId = gql/* GraphQL */ `
query ComByUserId(
  $filter: ModelAgendaCompanyFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $userId: String!
) {
  comByUserId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    userId: $userId
  ) {
    items {
      account_type
      address
      comId
      createdAt
      customer_id
      name
      phoneNumber
      suspended
      type
      updatedAt
      userId
      subscriptionId
      planId
      __typename
    }
    nextToken
    __typename
  }
}
`;